import { BindAll } from 'lodash-decorators'
import { AjaxBasics } from '../../helpers/ajaxBasics'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiAudit } from '@xt/client/api/audit'

@BindAll()
export class ControllerAudit {
  constructor($ajax: AjaxBasics) {}

  /** 举报违规内容 */
  async onReportViolation(entities: any) {
    const [, resp] = await $service<boolean>({
      url: EnumApiAudit.reportViolation,
      method: 'POST',
      data: entities
    })

    return resp
  }
}
export default ControllerAudit
